(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motoryva-brand-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-logo-carousel')) {
    customElements.define(
      'brand-logo-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-brand-viewport]');
          if (!this.viewport || this.dataset.ready === 'true') return;

          this.dataset.ready = 'true';
          this.dragging = false;
          this.dragMoved = false;
          this.startX = 0;
          this.startScrollLeft = 0;

          this.viewport.addEventListener('pointerdown', this.onPointerDown);
          this.viewport.addEventListener('pointermove', this.onPointerMove);
          this.viewport.addEventListener('pointerup', this.onPointerUp);
          this.viewport.addEventListener('pointercancel', this.onPointerUp);
          this.viewport.addEventListener('click', this.onClick, true);
          this.viewport.addEventListener('wheel', this.onWheel, { passive: false });
        }

        disconnectedCallback() {
          if (!this.viewport) return;

          this.viewport.removeEventListener('pointerdown', this.onPointerDown);
          this.viewport.removeEventListener('pointermove', this.onPointerMove);
          this.viewport.removeEventListener('pointerup', this.onPointerUp);
          this.viewport.removeEventListener('pointercancel', this.onPointerUp);
          this.viewport.removeEventListener('click', this.onClick, true);
          this.viewport.removeEventListener('wheel', this.onWheel);
        }

        onPointerDown = (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;

          this.dragging = true;
          this.dragMoved = false;
          this.startX = event.clientX;
          this.startScrollLeft = this.viewport.scrollLeft;
          this.viewport.classList.add('is-dragging');
          this.viewport.setPointerCapture(event.pointerId);
        };

        onPointerMove = (event) => {
          if (!this.dragging) return;

          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 5) this.dragMoved = true;
          this.viewport.scrollLeft = this.startScrollLeft - distance;
        };

        onPointerUp = (event) => {
          if (!this.dragging) return;

          this.dragging = false;
          this.viewport.classList.remove('is-dragging');
          if (this.viewport.hasPointerCapture(event.pointerId)) {
            this.viewport.releasePointerCapture(event.pointerId);
          }
        };

        onClick = (event) => {
          if (!this.dragMoved) return;

          event.preventDefault();
          event.stopPropagation();
          this.dragMoved = false;
        };

        onWheel = (event) => {
          if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

          const maxScrollLeft = this.viewport.scrollWidth - this.viewport.clientWidth;
          const nextScrollLeft = this.viewport.scrollLeft + event.deltaY;
          const canScrollBackward = event.deltaY < 0 && this.viewport.scrollLeft > 0;
          const canScrollForward = event.deltaY > 0 && this.viewport.scrollLeft < maxScrollLeft;

          if (!canScrollBackward && !canScrollForward) return;

          event.preventDefault();
          this.viewport.scrollLeft = Math.max(0, Math.min(maxScrollLeft, nextScrollLeft));
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motoryva-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-information-tabs')) {
    customElements.define(
      'product-information-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[data-product-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-product-panel]'));
          this.addEventListener('click', this.handleClick);
          this.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('click', this.handleDocumentClick);
          window.addEventListener('hashchange', this.handleHash);
          this.handleHash();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('keydown', this.handleKeydown);
          document.removeEventListener('click', this.handleDocumentClick);
          window.removeEventListener('hashchange', this.handleHash);
        }

        handleDocumentClick = (event) => {
          if (!(event.target instanceof Element) || !event.target.closest('[data-product-compatibility-trigger]')) return;
          const compatibilityTab = this.tabs.find((tab) => tab.dataset.productTab === 'compatibility');
          if (compatibilityTab) this.activate(compatibilityTab);
        };

        handleHash = () => {
          if (window.location.hash !== '#product-compatibility-details') return;
          const compatibilityTab = this.tabs.find((tab) => tab.dataset.productTab === 'compatibility');
          if (compatibilityTab) this.activate(compatibilityTab);
        };

        handleClick = (event) => {
          const tab = event.target.closest('[data-product-tab]');
          if (tab) this.activate(tab);
        };

        handleKeydown = (event) => {
          const tab = event.target.closest('[data-product-tab]');
          if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.tabs.indexOf(tab);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          this.tabs[nextIndex].focus();
          this.activate(this.tabs[nextIndex]);
        };

        activate(tab) {
          const target = tab.dataset.productTab;
          for (const item of this.tabs) {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          }
          for (const panel of this.panels) panel.hidden = panel.dataset.productPanel !== target;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parts-brands-directory"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('parts-brands-directory')) {
    customElements.define(
      'parts-brands-directory',
      class PartsBrandsDirectory extends HTMLElement {
        connectedCallback() {
          this.search = this.querySelector('[data-brand-search]');
          this.cards = [...this.querySelectorAll('[data-brand-card]')];
          this.count = this.querySelector('[data-brand-count]');
          this.empty = this.querySelector('[data-brand-empty]');
          this.search?.addEventListener('input', () => this.filterBrands());
        }

        normalize(value) {
          return value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLocaleLowerCase(document.documentElement.lang || 'fr');
        }

        filterBrands() {
          const query = this.normalize(this.search.value.trim());
          let visibleCount = 0;

          for (const card of this.cards) {
            const matches = this.normalize(card.dataset.brandName).includes(query);
            card.hidden = !matches;
            if (matches) visibleCount += 1;
          }

          this.count.textContent = this.dataset.brandCountTemplate.replace('__brand_total__', String(visibleCount));
          this.empty.hidden = visibleCount !== 0;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vehicle-fitment-selector')) {
    customElements.define(
      'vehicle-fitment-selector',
      class extends HTMLElement {
        async connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.form = this.querySelector('[data-vehicle-form]');
          this.brandSelect = this.querySelector('[data-vehicle-brand]');
          this.modelSelect = this.querySelector('[data-vehicle-model]');
          this.submitButton = this.querySelector('[data-vehicle-submit]');
          this.status = this.querySelector('[data-vehicle-status]');

          try {
            const payload = Array.from(this.querySelectorAll('[data-vehicle-selector-payload]'))
              .map((node) => node.textContent.trim())
              .join('');
            const bytes = Uint8Array.from(atob(payload), (character) => character.charCodeAt(0));
            const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
            this.data = JSON.parse(await new Response(stream).text());
            this.populate(
              this.brandSelect,
              this.data.brands,
              this.brandSelect.options[0].textContent,
              (brand) => brand.name,
            );
            this.brandSelect.disabled = false;
            this.status.textContent = '';
            this.bindEvents();
          } catch (error) {
            this.status.textContent = this.dataset.error;
          }
        }

        bindEvents() {
          this.brandSelect.addEventListener('change', () => {
            const brand = this.find(this.data.brands, this.brandSelect.value);
            this.resetSelect(this.modelSelect);
            this.status.textContent = '';
            this.submitButton.disabled = true;
            if (!brand) return;
            this.populate(
              this.modelSelect,
              brand.models,
              this.modelSelect.options[0].textContent,
              (model) => model.name,
            );
          });

          this.modelSelect.addEventListener('change', () => {
            const brand = this.find(this.data.brands, this.brandSelect.value);
            const model = this.find(brand?.models, this.modelSelect.value);
            this.status.textContent = '';
            this.submitButton.disabled = true;
            if (!model) return;
            const productCount = model.types?.reduce((total, type) => total + Number(type.count || 0), 0) || 0;
            this.submitButton.disabled = productCount < 1;
            this.status.textContent =
              productCount > 0
                ? ''
                : this.dataset.noResults;
          });

          this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            const brand = this.find(this.data.brands, this.brandSelect.value);
            const model = this.find(brand?.models, this.modelSelect.value);
            if (!brand || !model) return;

            const vehicleTags = [
              `CompatMarque:${brand.id}`,
              `CompatModele:${brand.id}|${model.id}`,
            ];
            const tagPath = vehicleTags.map((tag) => encodeURIComponent(tag)).join('+');
            window.location.assign(`${this.dataset.collectionUrl}/${tagPath}`);
          });
        }

        find(items, id) {
          return items?.find((item) => String(item.id) === String(id));
        }

        populate(select, items, placeholder, label) {
          select.replaceChildren(new Option(placeholder, ''));
          for (const item of items) select.add(new Option(label(item), item.id));
          select.disabled = false;
        }

        resetSelect(select) {
          select.selectedIndex = 0;
          while (select.options.length > 1) select.remove(1);
          select.disabled = true;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
